/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";
import acl from './acl';

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; // Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// API URL
Vue.prototype.$API = process.env.VUE_APP_API;

// Axios
import axios from "axios";
Vue.prototype.$axios = axios;

// NOTE: HTTPS Instance of Axios
const axiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_API}/api`,
});

axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("accessToken");
axiosInstance.defaults.headers.common["Accept"] = "application/json";

Vue.prototype.$axiosSecure = axiosInstance;

// NOTE: Client View Instance of Axios
const axiosClientInstance = axios.create({
  baseURL: `${process.env.VUE_APP_API}/api/rebates/client`
});

axiosClientInstance.interceptors.request.use(function (config) {
  let token = localStorage.getItem('clientToken');
  config.headers["Token"] = token;
  config.headers["Accept"] = "application/json";
  return config;
});

axiosClientInstance.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if(error.response && error.response.status == 401) {
    localStorage.removeItem('isPartnerLoggedIn');
    localStorage.removeItem('clientRebateStatus');
    localStorage.removeItem('loggedInPartnerId');
    localStorage.removeItem('loggedInPartnerName');
    localStorage.removeItem('clientToken');

    store.dispatch('setClientToken', null);
    store.dispatch('setClientRebateStatus', null);
    store.dispatch('setClientAMName', null);
		store.dispatch('setClientAMEmail', null);
    
    router.push({ path: '/partner/sign-on', query: { redirect: `/partner/current-cycle/${router.app._route.params.partnerName}`, partnerName: router.app._route.params.partnerName }});
  } 
  return Promise.reject(error);
})

Vue.prototype.$axiosSecureClient = axiosClientInstance;

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Vuexy Admin Filters
import "./filters/filters";

// Vuexy Admin Mixins
import "./mixins/mixins";

// VeeValidate
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Moment
import moment from "moment";
Vue.prototype.$moment = moment;

// Feather font icon
require("./assets/css/iconfont.css");

// Use custom dialog box for Rebates
import CustomPrompt from "./components/CustomPrompt.vue";
Vue.component("custom-prompt", CustomPrompt);

// Vue select css
// NOTE: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  acl,
  render: (h) => h(App),
}).$mount("#app");
